import {
  GridLayout,
  ParticipantTile,
  RoomAudioRenderer,
  useTracks,
  RoomContext,
  useRoomContext,
} from "@livekit/components-react";
import { Room, Track } from "livekit-client";
import "@livekit/components-styles";
import { useState, useEffect, useMemo } from "react";
import { gennerateToken, startRecording } from "@/livekitApi";
import { useAppContext } from "@/appContext";

const serverUrl = "wss://the-dev-difference-assessment-o3ojl221.livekit.cloud";

export default function App() {
  const { state } = useAppContext();

  const [room] = useState(
    () =>
      new Room({
        adaptiveStream: true,
        dynacast: true,
      })
  );

  useEffect(() => {
    let mounted = true;

    const connect = async () => {
      if (mounted) {
        const token = await gennerateToken(
          state.session.at(state.currentQuestion)?.sessionId || "room",
          state.profileUser?.name || "user"
        );
        await room.connect(serverUrl, token);
        await room.localParticipant.enableCameraAndMicrophone();
      }
    };
    connect();

    return () => {
      mounted = false;
      room.disconnect();
    };
  }, [room]);

  return (
    <RoomContext.Provider value={room}>
      <div data-lk-theme="default" className="size-[300px] w-[500px]">
        <MyVideoConference />
        <RoomAudioRenderer />
      </div>
    </RoomContext.Provider>
  );
}

function MyVideoConference() {
  const { state, reducers } = useAppContext();
  const tracks = useTracks([{ source: Track.Source.Camera }], {
    onlySubscribed: false,
  });

  const audioTracks = useTracks([{ source: Track.Source.Microphone }], {
    onlySubscribed: false,
  });

  const room = useRoomContext();

  const videoTrackSid = useMemo(() => {
    const videoTrack = tracks.find((t) => t.source === Track.Source.Camera);
    return videoTrack?.publication?.trackSid;
  }, [tracks]);

  const audioTrackSid = useMemo(() => {
    const audioTrack = audioTracks.find(
      (t) => t.source === Track.Source.Microphone
    );
    return audioTrack?.publication?.trackSid;
  }, [audioTracks]);

  useEffect(() => {
    if (!videoTrackSid && !state.egressId && !audioTrackSid) return;

    const startRecord = async () => {
      try {
        const resp = await startRecording(
          room.name,
          `${
            state.session.at(state.currentQuestion)?.videoid || "<sessionId>"
          }_${state.currentQuestion}`,
          videoTrackSid,
          audioTrackSid
        );

        reducers.setEgressId(resp.egressId||"");
      } catch (error) {
        console.error("Error starting recording:", error);
      }
    };
    if (!state.isPractice){startRecord();}
  }, [videoTrackSid]);

  return (
    <GridLayout
      tracks={tracks}
      style={{ height: "calc(100vh - var(--lk-control-bar-height))" }}
    >
      <ParticipantTile />
    </GridLayout>
  );
}
